import React, { useState } from "react";

const LoyaltyHistory = ({ profile }) => {

    const orders = [
        { id: 1, event: "Заказ #12345", date: "10.12.2024", points: "+50 баллов" },
        { id: 2, event: "Заказ #12346", date: "11.12.2024", points: "+30 баллов" },
        { id: 3, event: "Заказ #12347", date: "12.12.2024", points: "+20 баллов" },
        { id: 4, event: "Заказ #12348", date: "13.12.2024", points: "+40 баллов" },
        { id: 5, event: "Заказ #12349", date: "14.12.2024", points: "+60 баллов" },
        { id: 6, event: "Заказ #12350", date: "15.12.2024", points: "+70 баллов" },
        { id: 7, event: "Заказ #12351", date: "16.12.2024", points: "+80 баллов" },
        { id: 8, event: "Заказ #12352", date: "17.12.2024", points: "+90 баллов" },
    ];

    const [isHovered1, setIsHovered1] = useState(false);

    return (
        <div className="py-[16px] px-[20px] rounded-[15px] mt-[20px]"
            style={{ backgroundColor: '#fff' }}>
            <div className="text-[20px] font-semibold mb-[10px]">
                История баллов
            </div>
            <div className="">
                <div className="uppercase font-normal text-[14px] flex items-center justify-between mb-[13px]" style={{ color: '#1F222580' }}>
                    <div>Событие</div>
                    <div>Дата</div>
                    <div>Баллы</div>
                </div>
                <div className="h-[200px] md:h-[150px] overflow-y-auto">
                    {profile.bonus_usages.map((order, i) => {
                        const date = new Date(order.date);
                        return (
                            <div key={i} className="flex items-center gap-[15px] justify-between text-[12px] sm:text-[14px] font-normal py-[7px] border-b-[1px] border-solid"
                                style={{ borderColor: '#E8E8E8' }}>
                                <div>{order.name}</div>
                                <div>{date.toLocaleDateString("ru-RU")}</div>
                                <div className="font-semibold text-end">{order.points}</div>
                            </div>
                        )
                    })}
                </div>
            </div>
            <div className="w-full">
                <button className="w-full rounded-[35px] uppercase py-4 font-bold text-[14px] border-solid border-[1px] transition duration-300" style={{
                    color: isHovered1 ? '#fff' : '#C3372E',
                    backgroundColor: isHovered1 ? '#C3372E' : '#fff',
                    borderColor: '#C3372E'
                }}
                    onMouseEnter={() => setIsHovered1(true)}
                    onMouseLeave={() => setIsHovered1(false)}>
                    Посмотреть все
                </button>
            </div>
        </div>
    );
}

export default LoyaltyHistory;
